"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tapis Jobs API
 * The Tapis Jobs API executes jobs on Tapis systems.
 *
 * The version of the OpenAPI document: 0.1
 * Contact: cicsupport@tacc.utexas.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var runtime_1 = require("../runtime");
/**
* @export
* @enum {string}
*/
var JobListDTOStatusEnum;
(function (JobListDTOStatusEnum) {
    JobListDTOStatusEnum["Pending"] = "PENDING";
    JobListDTOStatusEnum["ProcessingInputs"] = "PROCESSING_INPUTS";
    JobListDTOStatusEnum["StagingInputs"] = "STAGING_INPUTS";
    JobListDTOStatusEnum["StagingJob"] = "STAGING_JOB";
    JobListDTOStatusEnum["SubmittingJob"] = "SUBMITTING_JOB";
    JobListDTOStatusEnum["Queued"] = "QUEUED";
    JobListDTOStatusEnum["Running"] = "RUNNING";
    JobListDTOStatusEnum["Archiving"] = "ARCHIVING";
    JobListDTOStatusEnum["Blocked"] = "BLOCKED";
    JobListDTOStatusEnum["Paused"] = "PAUSED";
    JobListDTOStatusEnum["Finished"] = "FINISHED";
    JobListDTOStatusEnum["Cancelled"] = "CANCELLED";
    JobListDTOStatusEnum["Failed"] = "FAILED";
})(JobListDTOStatusEnum = exports.JobListDTOStatusEnum || (exports.JobListDTOStatusEnum = {}));
function JobListDTOFromJSON(json) {
    return JobListDTOFromJSONTyped(json, false);
}
exports.JobListDTOFromJSON = JobListDTOFromJSON;
function JobListDTOFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'uuid': !runtime_1.exists(json, 'uuid') ? undefined : json['uuid'],
        'name': !runtime_1.exists(json, 'name') ? undefined : json['name'],
        'owner': !runtime_1.exists(json, 'owner') ? undefined : json['owner'],
        'appId': !runtime_1.exists(json, 'appId') ? undefined : json['appId'],
        'created': !runtime_1.exists(json, 'created') ? undefined : json['created'],
        'status': !runtime_1.exists(json, 'status') ? undefined : json['status'],
        'remoteStarted': !runtime_1.exists(json, 'remoteStarted') ? undefined : json['remoteStarted'],
        'ended': !runtime_1.exists(json, 'ended') ? undefined : json['ended'],
        'tenant': !runtime_1.exists(json, 'tenant') ? undefined : json['tenant'],
        'execSystemId': !runtime_1.exists(json, 'execSystemId') ? undefined : json['execSystemId'],
        'archiveSystemId': !runtime_1.exists(json, 'archiveSystemId') ? undefined : json['archiveSystemId'],
        'appVersion': !runtime_1.exists(json, 'appVersion') ? undefined : json['appVersion'],
        'lastUpdated': !runtime_1.exists(json, 'lastUpdated') ? undefined : json['lastUpdated'],
    };
}
exports.JobListDTOFromJSONTyped = JobListDTOFromJSONTyped;
function JobListDTOToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'uuid': value.uuid,
        'name': value.name,
        'owner': value.owner,
        'appId': value.appId,
        'created': value.created,
        'status': value.status,
        'remoteStarted': value.remoteStarted,
        'ended': value.ended,
        'tenant': value.tenant,
        'execSystemId': value.execSystemId,
        'archiveSystemId': value.archiveSystemId,
        'appVersion': value.appVersion,
        'lastUpdated': value.lastUpdated,
    };
}
exports.JobListDTOToJSON = JobListDTOToJSON;
